import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ServicesGrid } from './components/ServicesGrid';
import { ExtraServices } from './components/ExtraServices';
import { ExcellenceGallery } from './components/ExcellenceGallery';
import { Pricing } from './components/Pricing';
import { About } from './components/About';
import { Guarantee } from './components/Guarantee';
import { SocialProof } from './components/SocialProof';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from './components/Footer';
import { ReservationNotification } from './components/ReservationNotification';
import { SmsFloatingButton } from './components/SmsFloatingButton';
export function App() {
  return <div className="w-full min-h-full bg-white text-slate" data-id="element-0" data-mp="28tw62tsgwo4i">
      <Navbar data-id="element-1" data-mp="28sbbx5a2f776" />
      <main data-id="element-2" data-mp="23vciyq2516ak">
        <Hero data-id="element-3" data-mp="23vkuoemiy5k6" />
        <TrustBar data-id="element-4" data-mp="23w4gi6fape3h" />
        <ServicesGrid data-id="element-5" data-mp="23ujjma5idj2g" />
        <ExtraServices data-id="element-6" data-mp="23v2uj6wqr76z" />
        <ExcellenceGallery data-id="element-7" data-mp="3ijxnsm94vshs" />
        <Pricing data-id="element-8" data-mp="3ikqyfyb7r257" />
        <About data-id="element-9" data-mp="3ij66mgga9xb1" />
        <Guarantee data-id="element-10" data-mp="3ijpcgysnsv8p" />
        <SocialProof data-id="element-11" data-mp="3ii4ro0w5cqo1" />
        <QuoteForm data-id="element-12" data-mp="3mlat8v8bdto6" />
      </main>
      <Footer data-id="element-13" data-mp="3mk85uxa7a9d0" />
      <ReservationNotification data-id="element-14" data-mp="3mjzpgvevclx2" />
      <SmsFloatingButton data-id="element-15" data-mp="3rc9e8848zfxr" />
    </div>;
}